import { action, observable } from 'mobx'
import { ROOT } from '../../routes/app-routes'
import { postAuthLogic } from '../../utils/app-utils'
import { goTo } from '../../utils/router-utils'
import { USER_STORE } from '../stores'
import { getStore } from '../stores-repository'

export class LoginStore {
    @observable
    login = ''

    @observable
    password = ''

    @observable
    wrongPassword = false

    userStore = getStore(USER_STORE)

    @action
    updateLogin = login => {
        this.login = login
        this.wrongPassword = false
    }

    @action
    updatePassword = password => {
        this.password = password
        this.wrongPassword = false
    }

    submit = () => {
        this.userStore.authorized = true

        postAuthLogic()
        goTo(ROOT)
    }
}
